// Suche und Rubrik-Navigation sind bewusst entkoppelt (a-059):
// - Rubrik-Klick entfernt den Suchbegriff (Rubrik zeigt immer alle Artikel).
// - Suche mit Begriff entfernt Rubrikfilter (aslCategory und Legacy-Kategorien), die Suche läuft datenbankweit.
// - Suche ohne Begriff verhält sich wie bisher (Rubrik bzw. Katalog bleibt erhalten).

const SEARCH_PARAMS = ['search', 'query'];
const LEGACY_CATEGORY_PARAMS = ['categorySlug', 'subcategorySlug'];

function toSearchParams(routeQuery) {
  const source = typeof routeQuery === 'string'
    ? routeQuery
    : routeQuery?.toString?.() || '';
  return new URLSearchParams(source.startsWith('?') ? source.slice(1) : source);
}

function toCatalogUrl(query, pathname = '/catalog') {
  const serialized = query.toString();
  return `${pathname}${serialized ? `?${serialized}` : ''}`;
}

function removeParams(query, names) {
  names.forEach((name) => query.delete(name));
  return query;
}

// Suche innerhalb des aktuellen Katalogs: behält Rubrik, setzt den Begriff.
export function buildSearchUrl(routeQuery, term) {
  const query = toSearchParams(routeQuery);
  const normalizedTerm = String(term ?? '').trim();
  if (normalizedTerm) query.set('search', normalizedTerm);
  else query.delete('search');
  return toCatalogUrl(query);
}

// Suchabsenden. Mit Begriff: datenbankweite Suche, Rubrik wird entfernt.
// Ohne Begriff: Rubrik bzw. Katalog ohne Suchfilter (wie bisher).
export function buildSearchSubmitUrl(routeQuery, term, legacyCategorySlug = '') {
  const normalizedTerm = String(term ?? '').trim();
  const query = toSearchParams(routeQuery);

  if (normalizedTerm) {
    removeParams(query, ['aslCategory', ...LEGACY_CATEGORY_PARAMS]);
    query.set('search', normalizedTerm);
    return toCatalogUrl(query);
  }

  removeParams(query, SEARCH_PARAMS);
  const pathname = !query.has('aslCategory') && legacyCategorySlug
    ? `/catalog/${legacyCategorySlug}`
    : '/catalog';
  return toCatalogUrl(query, pathname);
}

// Rubrik-Klick (Mega-Menü, Breadcrumb, Rubrik-Filter): Suchbegriff wird entfernt.
// Mit { keepSearch: true } bleibt er erhalten (reine Legacy-URL-Kanonisierung ohne Nutzerklick).
export function buildCanonicalAslUrl(routeQuery, key, { keepSearch = false } = {}) {
  const query = toSearchParams(routeQuery);
  query.delete('aslCategory');
  if (!keepSearch) removeParams(query, SEARCH_PARAMS);
  if (key) query.set('aslCategory', key);
  return toCatalogUrl(query);
}
